// extracted by mini-css-extract-plugin
export default {"filesListWrapper":"zsAy2zIzN8v8SmHhIAQT","listItem":"bBGvDavBGz7Asu5VIICQ","text":"ZCSYbT0eZfuVCTziP4f6","icon":"RBUn1JFfQf_g5614qtQO","removeIcon":"t7r6ziEdD8yEgRFTiMQC"};